import generatePDF from 'react-to-pdf';
import { enqueueSnackbar } from 'notistack';

/**
 * Formats a JavaScript Date object or a date string into `YYYY-MM-DD` format.
 *
 * @param {Date|string|number} date - The date to format.
 * @returns {string} - Formatted date in `YYYY-MM-DD`.
 */
const getFormatDateYMD = (date) => {
    const d = new Date(date);
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
};

/**
 * Returns current timestamp as `YYYY-MM-DD-HH-MM`.
 *
 * @returns {string}
 */
const getCurrentTimestamp = () => {
    const now = new Date();
    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    const hh = String(now.getHours()).padStart(2, '0');
    const min = String(now.getMinutes()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}-${hh}-${min}`;
};

/**
 * Handles PDF export logic.
 *
 * @param {Object} options
 * @param {Object} options.targetRef - React ref to export
 * @param {Object} options.calender - Redux calendar state
 * @param {string} options.accountName - Account name for filename
 * @param {Function} options.setIsExporting - Loading toggle
 */
export const handleExportClick = async ({ targetRef, calender, accountName, setIsExporting }) => {
    setIsExporting(true);
    try {
        const timestamp = getCurrentTimestamp();

        const startDate = getFormatDateYMD(calender?.currentDateRange?.startDate);
        const endDate = getFormatDateYMD(calender?.currentDateRange?.endDate);
        const compareStart = calender?.comparitionDateRange?.startDate;
        const compareEnd = calender?.comparitionDateRange?.endDate;

        const dateRange = `${startDate}_${endDate}`;
        const compareRange =
            compareStart && compareEnd
                ? `_compare-${getFormatDateYMD(compareStart)}_${getFormatDateYMD(compareEnd)}`
                : "";

        const sanitizedAccountName = (accountName || "account")
            .replace(/\s+/g, '_')
            .replace(/[^a-zA-Z0-9-_]/g, '');

        const filename = `Landing_Page_Export_${sanitizedAccountName}_${timestamp}_${dateRange}${compareRange}.pdf`;

        await generatePDF(targetRef, {
            filename,
            page: { format: "A2" },
            scale: 0.8,
        });
    } catch (error) {
        enqueueSnackbar("PDF Export Failed", { variant: "error" });
    } finally {
        setIsExporting(false);
    }
};
